// MessagesBell — global navbar widget that links to /shadow/mensajes and
// shows an unread count badge that polls every 30 seconds. Mirrors the
// NotificationBell pattern so it slots seamlessly next to it.
import React, { useEffect, useState } from "react";
import { Link, useLocation } from "react-router-dom";
import axios from "axios";
import { MessageCircle } from "lucide-react";
import { API_BASE as API } from "../../lib/api";

const POLL_MS = 30000;

export const MessagesBell = () => {
  const [unread, setUnread] = useState(0);
  const location = useLocation();

  useEffect(() => {
    let alive = true;
    const fetchCount = async () => {
      try {
        const { data } = await axios.get(`${API}/api/shadow/messages/unread/count`);
        if (alive) setUnread(Number(data?.count) || 0);
      } catch {
        /* silent — unauth or transient */
      }
    };
    fetchCount();
    const id = setInterval(fetchCount, POLL_MS);
    return () => {
      alive = false;
      clearInterval(id);
    };
    // Re-fetch when route changes so the badge clears immediately after
    // visiting /shadow/mensajes (where messages get marked read).
  }, [location.pathname]);

  return (
    <Link
      to="/shadow/mensajes"
      data-testid="navbar-messages-bell"
      title="Mensajes"
      className="relative inline-flex h-9 w-9 shrink-0 items-center justify-center rounded-full text-white/75 transition-colors hover:bg-white/10 hover:text-white"
    >
      <MessageCircle className="h-4 w-4" strokeWidth={1.8} />
      {unread > 0 && (
        <span
          data-testid="navbar-messages-unread-badge"
          className="absolute -right-0.5 -top-0.5 inline-flex h-4 min-w-[16px] items-center justify-center rounded-full bg-amber-400 px-1 text-[9px] font-black text-black"
        >
          {unread > 99 ? "99+" : unread}
        </span>
      )}
    </Link>
  );
};

export default MessagesBell;
